import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../components-css/case-study-listing.scss';
import data from '../data/caseStudies.json';
import axios from 'axios';
import { BASE_URL } from '../config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SITE_KEY = '6LebgI4rAAAAAPhRn6VH0DW687PInYqxB8BPxsXE'

const allCards = [
  {
    id: "r3-business",
    cardTitle: "The Digital Evolution Of R3 Business Solution",
    cardImage: "/r3-img.png",
    cardLogoText: "/r3logo.png",
    hasDetail: true,
  },
  {
    id: "sedona-investing",
    cardTitle: "Modernizing The Online Journey For Investors Sedona Investing",
    cardImage: "/sedona.png",
    cardLogoText: "/sedonalogo.png",
    hasDetail: true,
  },
  {
    id: "calhoun-tech",
    cardTitle: "Revamping Digital Sales For IT Equipment Brand Calhoun Technologies",
    cardImage: "/calhoun.png",
    cardLogoText: "/calhounlogo.png",
    hasDetail: true,
  },
  {
    id: "purosurf",
    cardTitle: "Building A Seamless Online Journey For Surfing Enthusiasts Purosurf",
    cardImage: "/surfing.png",
    cardLogoText: "/surflogo.png",
    hasDetail: true,
  },
  {
    id: "novfeel",
    cardTitle: "Scaling Online Presence With Performance-Driven Seo — Novfeel",
    cardImage: "/novfeel.png",
    cardLogoText: "/novfeellogo.png",
    hasDetail: true,
  },
  {
    id: "uprivate-label",
    cardTitle: "Building A Stronger Online Identity For Uprivate Label",
    cardImage: "/uprivate.png",
    cardLogoText: "/uprivatelogo.png",
    hasDetail: true,
  },
];

export default function SeoCasestudyPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);

  // ✅ Load reCAPTCHA script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleCardClick = (card) => {
    if (card.hasDetail) {
      navigate(`/seo-case-study/${card.id}`);
    }
  };

  const handleSend = () => {
    if (!inputRef.current.checkValidity()) {
      inputRef.current.reportValidity();
      return;
    }
    sendEmail();
  };

  const sendEmail = async () => {
    if (!email) {
      toast.error('Email Address is required', { autoClose: 3000 });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address', { autoClose: 3000 });
      return;
    }

    setIsLoading(true);

    try {
      let token = null;

      if (window.grecaptcha) {
        await window.grecaptcha.ready(async () => {
          token = await window.grecaptcha.execute(SITE_KEY, {
            action: 'submit',
          });
        });
      }

      const payload = {
        email,
        recaptchaToken: token,
      };

      const response = await axios.post(
        `${BASE_URL}/consult-with-us`,
        payload
      );

      if (response.data?.status === true) {
        setEmail('');
        toast.success(response.data.message || 'Email sent successfully!', {
          autoClose: 3000,
        });
      } else {
        toast.error(response.data?.message || 'Something went wrong', {
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to send email',
        { autoClose: 3000 }
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />

      {/* HERO */}
      <section className="seo-listing-hero">
        <div className="seo-listing-hero-content">
          <h1>Search Engine Optimization</h1>
          <h1><span>Case Studies</span></h1>
          <p className="seo-listing-hero-desc">
            Discover how our expert SEO solutions elevated rankings, visibility, and organic traffic for various brands.
          </p>

          <div className="seo-listing-hero-form">
            <input
              ref={inputRef}
              type="email"
              placeholder="Enter your work email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              required
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !isLoading) {
                  handleSend();
                }
              }}
            />
            <button
              type="button"
              disabled={isLoading}
              onClick={handleSend}
            >
              {isLoading ? 'Sending...' : 'Get Free Analysis Report'} <span>↗</span>
            </button>
          </div>
        </div>
      </section>

      <div className="seo-listing-bottom-bar" />

      {/* CARD GRID */}
      <section className="seo-listing-grid-section">
        <div className="seo-listing-grid">
          {allCards.map((card) => (
            <div
              key={card.id}
              className={`seo-case-card ${card.hasDetail ? 'clickable' : ''}`}
              onClick={() => handleCardClick(card)}
            >
              <div className="seo-card-img-wrap">
                <img src={card.cardImage} alt={card.cardTitle} loading="lazy" />
              </div>
              <div className="seo-card-body">
                <div className="seo-card-logo">
                  <img src={card.cardLogoText} alt="logo" />
                </div>
                <div className="seo-card-title">{card.cardTitle}</div>
                <div className="seo-card-divider" />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}